import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Footer Group - Main",
  icon: "list-view",
  lazyLoad: false,
}

export default defineBlock("parts/footer-group-main", (props) => {
  return (
    <div className="pb-5">
      <EditableText as="div" store="label" placeholder="Title" plainText className="type-label-caps mb-3 text-fg" />
      <div className="el-a:inline-block el-a:py-[0.3em] el-a:underline-offset-4 el-a:transition-colors el-a:duration-150 el-a:underline el-a:decoration-transparent hover:el-a:decoration-fg/50 focus:el-a:decoration-fg/50 hover:el-a:text-fg focus:el-a:duration-0 el-a:rounded-sm el-a:px-2 el-a:-mx-2 el-a:type-ui-m el-a:text-fg-secondary">
        <InnerBlocks
          allowedBlocks={["core/navigation-link"]}
          appender={{ type: "simple" }}
          adminClassName="stack-y-2"
          orientation="vertical"
        />
      </div>
    </div>
  )
})
